import { OfferingStatus } from '@arrived/models';

export const shouldUseSharesAvailableEndpoint = (status: OfferingStatus) =>
  status === OfferingStatus.TRANSACT_ALL ||
  status === OfferingStatus.TRANSACT_RESERVATIONS ||
  status === OfferingStatus.TRANSACT_EARLY_ACCESS ||
  status === OfferingStatus.RESERVATIONS;
